"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[5023],{

/***/ 5895
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _theme_controllers_cart_utils_controller__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8078);
/* harmony import */ var _core_factories_cart_items_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4708);
/* harmony import */ var _customer_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5633);
/* harmony import */ var _theme_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8884);





class ProductCardController extends _theme_controllers_cart_utils_controller__WEBPACK_IMPORTED_MODULE_0__.CartUtilsController {
  static values = {
    variantId: String,
    variantPrice: String,
    productId: String,
    productTitle: String,
    sellingPlanId: String,
    sellingPlanAllocations: Array,
    currentQty: { type: Number, default: 0 },
  }

  static outlets = ['sidecart']
  static targets = ['addButton', 'buttonText']

  sidecartOutletConnected() {
    this.refreshQuantity()
  }

  matchSellingPlanId(sellingPlanName) {
    if (!sellingPlanName) return null

    const matchingAllocation = this.sellingPlanAllocationsValue.find(
      alloc => alloc.selling_plan?.name?.toLowerCase() === sellingPlanName.toLowerCase()
    )

    return matchingAllocation
      ? (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureNoGid)(matchingAllocation.selling_plan.id.toString())
      : null
  }

  refreshQuantity() {
    const bundleItems = this.firstBundleItems()
    const productId = this.productIdValue

    this.currentQtyValue = bundleItems
      .filter(item => (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureNoGid)(item.merchandise.product.id) === productId)
      .reduce((total, item) => total + item.quantity, 0)
  }

  currentQtyValueChanged() {
    if (!this.hasAddButtonTarget) return
    if (this.addButtonTarget.disabled) return

    const qty = this.currentQtyValue
    this.addButtonTarget.dataset.productCurrentQty = qty

    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = qty === 0
        ? 'ADD'
        : qty === 1
          ? '1 PACK'
          : `${qty} PACKS`
    }
  }

  onSidecartUpdated() {
    if (!this.hasSidecartOutlet) return
    this.refreshQuantity()
  }

  async addProductToCart() {
    this.addButtonTarget.disabled = true

    try {
      const firstBundleItems = this.firstBundleItems()
      const firstBundleItem = firstBundleItems[0]

      const existingSellingPlanName = firstBundleItem
        ? firstBundleItem.sellingPlanAllocation?.sellingPlan?.name
        : _theme_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_DELIVERY_FREQUENCY

      const sellingPlanId = this.matchSellingPlanId(existingSellingPlanName)
        || (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureNoGid)(this.sellingPlanIdValue)

      const items = _core_factories_cart_items_factory__WEBPACK_IMPORTED_MODULE_1__.CartItemsFactory.create({
        variantId: this.variantIdValue,
        productId: this.productIdValue,
        quantity: 1,
        sellingPlanId,
        source: 'customer',
        bundleItems: [{
          variantId: this.variantIdValue,
          productId: this.productIdValue,
          quantity: 1,
          sellingPlanId,
        }],
        bundleProductHandle: _theme_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_BUNDLE_PRODUCT_HANDLE,
        bundleProductId: _theme_constants__WEBPACK_IMPORTED_MODULE_3__.COFFEE_BUNDLE_PRODUCT_ID,
        bundleVariantId: _theme_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_BUNDLE_VARIANT_ID,
        bundleCollectionId: _theme_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_BUNDLE_COLLECTION_ID,
      })

      await this.sidecartOutlet.addItems(items)
      this.refreshQuantity()
      this.sidecartOutlet.open('ProductCard')
    } finally {
      this.addButtonTarget.disabled = false
    }
  }

  async removeFromCart() {
    this.addButtonTarget.disabled = true

    try {
      const bundleItems = this.firstBundleItems()
      const matchingItem = bundleItems.find(
        item => (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureNoGid)(item.merchandise.product.id) === this.productIdValue
      )

      if (!matchingItem) return

      if (matchingItem.quantity > 1) {
        await this.updateCart([{
          id: matchingItem.id,
          quantity: matchingItem.quantity - 1,
        }])
      } else {
        await this.removeCartItems([matchingItem.id])
      }

      this.refreshQuantity()
    } finally {
      this.addButtonTarget.disabled = false
    }
  }
}

Stimulus.register('product-card', ProductCardController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(5895)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);